<!--
 * @Author: guoyukun 527656877@qq.com
 * @Date: 2026-09-23 10:04:20
 * @LastEditors: guoyukun 527656877@qq.com
 * @LastEditTime: 2026-09-23 10:43:21
 * @FilePath: \H5SDK_DEV1\source_code\webpay_riceshell\src\components\footer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="footer">
    <div class="footer-main">
      <p><a href="http://beian.miit.gov.cn" target="_blank">{{data.text1}}</a></p>
      <p>{{data.text2}}</p>
      <p>{{data.text3}}</p>
      <!-- <p><router-link target="_blank" v-if="data.privacy" :to="data.url">{{data.privacy}}</router-link> </p> -->
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        data:''
      }
    },
    props: {
        resData: {
        }
    },
    watch: {
        resData(newData){
            this.data=newData;
        }
    },
  }
</script>

<style scoped>
  .footer{
    padding-top: 110px;
    /* height: 230px; */
    background: url('~@/assets/images/footer-bg1.png') right no-repeat, url('~@/assets/images/footer-bg2.png') left no-repeat,#F7F7F7;
    background-size: auto 100%;
    box-sizing: border-box;
  }
  .footer-main{
    display: block;
    height: 100%;
    width: 100%;
    background-color: #333;
    text-align: center;
    box-sizing: border-box;
    padding: 20px 10px;
  }
  .footer-main p,.footer-main p a{
    color: white;
    font-size: 18px;
  }
  .footer-main p:nth-of-type(2){
    cursor: pointer;
    margin-top: 10px;
  }
  @media screen and (max-width: 1000px){
    .footer-main p{
      color: white;
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue